import { ABaseModel } from '@pperform/pp-data-mappers';
import { EventTypeMasterData } from 'interfaces/EventTypeMasterData.model';
import {
  formatDateTime,
  convertTrackingEventDateTime,
} from '@pperform/pp-utils/datetime.utils';
import { fetchReturnTicket } from '../fetchers';

export interface ReturnEvent {
  eventType: string;
  eventTime: string;
  parsedEventTimeTimezone: string;
  eventTypeMasterData?: EventTypeMasterData;
}

export interface ReturnRequestTicketParams {
  shipmentPk?: number;
  orderId?: string;
}

export class ReturnTicketDTO extends ABaseModel {
  shipmentPk: number = undefined;

  orderId: string = undefined;
}

// -- EVENT --

export const getEventDisplayName = (
  event: ReturnEvent,
  translateMasterEvent = (data: string): string => data,
): string => {
  const eventTypeMasterKey = event.eventTypeMasterData?.key;

  // NOTE: ATM42 - UC6.3
  if (eventTypeMasterKey === 'RETURN_EVENT_BOOKED_SUCCESS') {
    return translateMasterEvent('RETURN_EVENT_BOOKED_SUCCESS_TEXT');
  }

  if (eventTypeMasterKey) return translateMasterEvent(eventTypeMasterKey);
  return event.eventType;
};

export const getEventDisplayTime = (
  event: ReturnEvent,
  config: {
    timezone?: string;
    locale?: string;
    displayFormat?: string;
  } = {},
): string => {
  const { convertedTime } = convertTrackingEventDateTime(
    event.eventTime,
    event.parsedEventTimeTimezone,
    config.timezone,
  );

  return formatDateTime(convertedTime, config.displayFormat, config.locale);
};

// -- END - EVENT --

export const getEncryptedReturnPk = async (
  orgId: number,
  params: ReturnRequestTicketParams,
): Promise<string> => {
  const payload = ReturnTicketDTO.create({ ...params }).toApiData();
  const { data } = await fetchReturnTicket(orgId, payload);
  return data?.return_pk;
};
